import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["status"]
  static values = {
    url: String,
    complete: Boolean,
    pollInterval: Number
  }
  connect() {
    // Initialize the pollTimer as null
    this.pollTimer = null
    // Only start polling if not complete AND no processor errors
    if (!this.completeValue) {
      this.startPolling()
    } else {
      // Check if there are errors to show a notification
      this.checkForProcessorErrors()
    }
  }
  disconnect() {
    this.stopPolling()
  }
  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }
  startPolling() {
    // Default interval of 3 seconds if not specified
    const interval = this.pollIntervalValue || 3000
    // Make an immediate first check
    this.checkStatus()
    // Then set up the interval
    this.pollTimer = setInterval(() => {
      this.checkStatus()
    }, interval)
  }
  checkForProcessorErrors() {
    fetch(this.urlValue)
      .then(response => response.json())
      .then(data => {
        // Check if there are payment processor errors
        if (data.payment_processor_errors) {
          const event = new CustomEvent("payment:updated", {
            detail: {
              status: "failed",
              message: data.payment_processor_errors
            }
          })
          window.dispatchEvent(event)
        }
      })
      .catch(error => console.error("Error checking for processor errors:", error))
  }

  checkStatus() {
    fetch(this.urlValue)
      .then(response => response.json())
      .then(data => {
        // Always update the HTML content regardless of status
        if (data.html) {
          this.statusTarget.innerHTML = data.html
        }

        // Check for payment processor errors
        if (data.payment_processor_errors) {
          this.stopPolling()

          document.querySelectorAll('.alert').forEach(alert => {
            if (alert.textContent.includes('provisionally created')) {
              alert.remove();
            }
          });

          const event = new CustomEvent("payment:updated", {
            detail: {
              status: "failed",
              message: data.payment_processor_errors
            }
          })
          window.dispatchEvent(event)
          // Mark as complete to prevent future polling
          this.completeValue = true
          return
        }

        // If payment is complete, failed, or has an error, stop polling
        if (data.status === "paid" || data.status === "failed" || data.status === "error") {
          this.stopPolling()

          // Find all alerts with text containing "provisionally created"
          document.querySelectorAll('.alert').forEach(alert => {
            if (alert.textContent.includes('provisionally created')) {
              alert.remove();
            }
          });

          // Mark as complete to prevent future polling
          this.completeValue = true

          // Show notification
          const event = new CustomEvent("payment:updated", {
            detail: { status: data.status, message: data.message }
          })
          window.dispatchEvent(event)
        }
      })
      .catch(error => {
        console.error("Error checking payment status:", error)
        // Handle fetch errors by stopping the polling and showing an error notification
        this.stopPolling()

        document.querySelectorAll('.alert').forEach(alert => {
          if (alert.textContent.includes('provisionally created')) {
            alert.remove();
          }
        });

        const event = new CustomEvent("payment:updated", {
          detail: {
            status: "error",
            message: "An error occurred while checking payment status. Please refresh the page or try again later."
          }
        })
        window.dispatchEvent(event)
      })
  }
}
